/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
 import PRM from "@/core/PermissionConstants";
 import  RouteConstants  from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.AUDIOMETRY_HISTORY.path,
  name: RouteConstants.AUDIOMETRY_HISTORY.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/AudiometryHistoryService"),
    table: () =>  import("@/app/components/audiometry/history/AudiometryHistoryTable"),
    form: () =>  import("@/app/components/audiometry/history/AudiometryHistoryForm"),
    header: {
      icono: "mdi-eye",
      texto: "Historial de consultas | Audiometría",
      textNew: "Atender Consulta | Audiometría",
      textEdit: "Editar Consulta | Audiometría",
      textView: "Visualizar consulta | Audiometría"
    },
    prm: PRM.MODULE_AUDIOMETRY_HISTORY,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    labelDate: "Seleccione fecha",
    namePDF: "Audiometría"
  },
};
